import { Button, Card } from "@fluentui/react-northstar";
import { Container, ContainerFluid } from "../../common/styles";

import { TeamSection } from "./components/TeamSection";
import { ContactKey } from "./components/ContactKey";
import { ActivitySection } from "./components/ActivitySection";
import { MainSection } from "./components/MainSection";
import { MyActivitySection } from "./components/MyActivitySection";
import { SocietyDocuments } from "./components/SocietyDocuments";
import SocietyActivity from "./components/SocietyActivity";
import { ROLES_CODE } from "../../constants/roles";
import CustomBreadCrumb from "../../components/breadcrumb";
import { BREADCRUMB_HUMBERGER_GLOBAL } from "../../constants/routes/drawer";
import { BREADCRUMB_HOME } from "../home/contants";
import DisplayTasks from "../home/components/DisplayTasks";
import ChartN2F from "./components/ChartN2F";
import Onboarding from "../onboarding";
import { ROUTES } from "../../constants/routes";
import Toast from "../../components/Alerts";
import SearchBarFromDashboard from "./components/SearchBarFromDashboard";
import Feedback from "../../components/Feedback";
import { Main, RightSide } from "./styles/responsive";
import { PeopleAdd28Regular } from "@fluentui/react-icons";
import styled from "styled-components/macro";
import { DEVICE } from "../../constants/responsive";
import withAuth from "../../HOC/withAuth";
import withRole from "../../HOC/withRole";
import useDashboard from "./hooks/useDashboard";
import CardFeature from "../../components/Cards/CardFeature/CardFeature";
import CardProgressFactsheet from "../pre_onboarding/components/CardProgressFactsheet";

const NewDashboard = () => {
    const {
        navigate,
        query,
        roles,
        toast,
        dashboardData,
        canSeeFactsheetCard,
    } = useDashboard();

    return (
        <ContainerFluid column>
            <Toast
                onStatusChange={() =>
                    toast.setConfigToast({
                        visible: false,
                        content: "",
                        level: "success",
                    })
                }
                level={toast.configToast.level}
                content={toast.configToast.content}
                visible={toast.configToast.visible}
                dismissible={true}
            />
            <CustomBreadCrumb
                humberger={BREADCRUMB_HUMBERGER_GLOBAL()}
                navList={BREADCRUMB_HOME}
                actions={
                    roles.isRH && (
                        <ButtonStyle
                            content={"Ajouter un collaborateur"}
                            icon={<PeopleAdd28Regular outline />}
                            iconPosition="after"
                            onClick={() => navigate(ROUTES.employee_add)}
                            flat
                        />
                    )
                }
                searchBar={<SearchBarFromDashboard />}
            />

            <ContainerFluid
                column
                styles={{
                    backgroundColor: "#fafafa",
                    minHeight: "100vh",
                    paddingBottom: "50px",
                }}
            >
                <ContainerStyle hAlign="center" gap="gap.medium">
                    {/* Main Content */}
                    <Main column>
                        {/* le main Section contient profile card + activity mensuell card + Absence card  */}
                        <MainSection
                            me={dashboardData.me}
                            monthly_activity={dashboardData.monthly_activity}
                            balances={dashboardData.balances}
                            is_pre_onboarding={dashboardData.is_pre_onboarding}
                            isLoading={query.isLoadingDashboardData}
                        />
                        <MyActivitySection
                            isManager={roles.isManager}
                            isRH={roles.isRH}
                            activities={dashboardData.activities}
                        />
                        {roles.isRH && (
                            <SocietyDocuments
                                company_documents={
                                    dashboardData.company_documents
                                }
                                id_folder_society={
                                    dashboardData.company_folder_id
                                }
                            />
                        )}
                        {roles.isManager && (
                            <TeamSection team={dashboardData.team} />
                        )}
                        {/* {!isManager && !isRH && ( */}

                        {!roles.isRH &&
                            dashboardData.current_status?.value === 1 && (
                                <DisplayTasks
                                    tasks={dashboardData.tasks}
                                    onboarding_steps={
                                        dashboardData.onboarding_steps
                                    }
                                />
                            )}

                        <ContactKey
                            is_pre_onboarding={dashboardData.is_pre_onboarding}
                            key_contacts={dashboardData.key_contacts}
                        />
                    </Main>
                    {/* Right side - Team Activity + N2F  */}
                    <RightSide column gap="gap.large">
                        {canSeeFactsheetCard && (
                            <CardProgressFactsheet
                                isLoading={query.isLoadingDashboardData}
                                completeness_due_date={
                                    dashboardData.activities
                                        ?.completeness_due_date
                                }
                                completeness_percentage={
                                    dashboardData.activities
                                        ?.completeness_percentage
                                }
                                completeness_status_id={
                                    dashboardData.activities
                                        ?.completeness_status?.id
                                }
                                id_user={dashboardData.me?.id}
                                fromPage="dashboard"
                            />
                        )}
                        {dashboardData.isExpenseReportActivated && (
                            <ChartN2F
                                expenses={dashboardData.expenses}
                                isManager={roles.isManager}
                                is_pre_onboarding={
                                    dashboardData.is_pre_onboarding
                                }
                                isLoading={query.isLoadingDashboardData}
                            />
                        )}
                        <SocietyActivity
                            title={"Activités de l'entreprise"}
                            company_activities={dashboardData.team_activities}
                        />

                        {/* for manager */}
                        {roles.isManager && (
                            <ActivitySection
                                team_activities={dashboardData.team_activities}
                            />
                        )}
                        <CardFeature />
                    </RightSide>
                </ContainerStyle>

                <Onboarding />
                {/* <Feedback /> */}
            </ContainerFluid>
        </ContainerFluid>
    );
};

export default withAuth(withRole([ROLES_CODE.employee])(NewDashboard));

const ContainerStyle = styled(Container)`
    @media ${DEVICE.mobileS} {
        flex-direction: column;
    }
    @media ${DEVICE.tablet} {
        flex-direction: column;
    }
    @media ${DEVICE.laptop} {
        flex-direction: row;
    }
    @media ${DEVICE.laptopL} {
        flex-direction: row;
    }
`;
const ButtonStyle = styled(Button)`
    @media ${DEVICE.mobileS} {
        min-width: 30px;
        padding-inline: 8px;
        .ui-button__content {
            display: none;
        }
        .ui-box {
            margin-left: 0px;
        }
    }
    @media ${DEVICE.tablet} {
        min-width: 96px;
        padding-inline: 20px;
        .ui-button__content {
            display: block;
        }
        .ui-box {
            margin-left: 10px;
        }
    }
    @media ${DEVICE.laptop} {
        .ui-button__content {
            display: block;
        }
    }
`;
